import {useEffect, useState} from "react";

const LoadingDots = ({interval = 250, char = '.', max = 3}: { interval?: number, char?: string, max?: number }) => {
    const [dots, setDots] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setDots((dots + 1) % max)
        }, interval);
        return () => clearInterval(timer);
    });

    return <span>{char.repeat(dots + 1)}</span>
}

export default LoadingDots
